import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Usuario } from '../../model/usuario';
import {Router} from '@angular/router';
import { Session } from 'src/app/model/session';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { StorageService } from 'src/app/service/storage.service';
import { ModalVideoComponent } from '../jardin/components/dialogs/modal-video/modal-video.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalRecuperarPasswordComponent } from '../jardin/components/dialogs/modal-recuperar-password/modal-recuperar-password.component'
import Swal from 'sweetalert2';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
 
  loginForm;
  //parametroBlock:number =0;
  loginOK;
  public usuario = new Usuario();

  constructor(
    private formBuilder: FormBuilder, 
    public authenticationService: AuthenticationService,
    private storageService: StorageService,
    public dialog: MatDialog,
    private router: Router) { }

  ngOnInit(): void {
    this.loginOK = true;
    this.loginForm = this.formBuilder.group({
      usuario: '',
      password: ''
    });
    
  }

  login(){
    //this.obtenerParametro();
    this.usuario = this.loginForm.value;
    //if(this.parametroBlock==1 || this.usuario.usuario=='admin'){
   
    this.authenticationService.login(this.usuario).subscribe(
      result => {
        switch(result.payload.rol){
          case 'us_persona':{
            let sesion = new Session;
            let usuario = new Usuario;
            usuario.idUsuario =  result.payload.id;
            usuario.usuario = result.payload.name;
            usuario.password = '*****************';
            sesion.ususario = usuario;
            sesion.perfil = result.payload.perfil;
            this.correctLogin(sesion);
            switch(sesion.perfil){
              case "admin":
                this.router.navigate(['/administrador'])
                break;
              case "tutor":
                this.router.navigate(['/tutor'])
                break;
              case "mega-tutor":
                this.router.navigate(['/mega-tutor'])
                break;
              case "asesor-tecnico":
                this.router.navigate(['/asesor-tecnico'])
                break;
              case "":
                this.router.navigate(['/equipo-pedagogico'])
                break;
            }
            
            break;
          }
          case 'us_jardin':{      
            let sesion = new Session;
            let usuario = new Usuario;
            usuario.idUsuario =  result.payload.id;
            usuario.usuario = result.payload.name;
            usuario.password = '*****************';
            sesion.ususario = usuario;
            sesion.perfil = 'us_jardin';
            this.correctLogin(sesion);
            this.router.navigate(['/jardin'],{queryParams: { id: result.payload.id }, skipLocationChange: true})
            break;
          }
        
          default:{
            this.router.navigate(['/login'])
            break;
          }
        }
      },
      err => {
        this.loginOK = false;
        console.log(err);
      });
    /*}else{
       Swal.fire({
         title: 'Error al Iniciar Session',
         text: 'No se puede acceder al sistema, en Mantencion1111.',
         icon: 'error',
         confirmButtonText: 'OK'
       })
   }*/
  }

  private correctLogin(data: Session){
    this.storageService.setCurrentSession(data);
  }

  recuperarPassword(){ 
    const dialogRef = this.dialog.open(ModalRecuperarPasswordComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => {
      console.log('Mensaje desde la modal: '+result);      
      if(result=='refresh'){
      

      }
    });
  }

 showPreguntasFrecuentes(){
  const dialogRef = 
  this.dialog.open(ModalVideoComponent, {
    disableClose: true ,
    data: {url: 'assets/documentos/2021/FAQ_MGCEP.pdf',size: 'xl'}
  });

  dialogRef.afterClosed().subscribe(result => {
  });

 }

  /* obtenerParametro(){
     this.authenticationService.obtenerParametro(2).subscribe((response:any) => {
       this.parametroBlock = response.payload;
     },
     (err) => { 
       console.log(err)
       this.parametroBlock = 0;
     });
   }*/
}
